export const scriptPayAddress = process.env.REACT_APP_SCRIPTPAYADDRESS;
export const scriptGlassesAddress = process.env.REACT_APP_SCRIPTGLASSESADDRESS;

export const scriptVoucherAddress = process.env.REACT_APP_SCRIPTVOUCHERADDRESS;

export const scriptTvAddress = process.env.REACT_APP_SCRIPTTVADDRESS;
export const marketplaceAddress = process.env.REACT_APP_MARKETPLACEADDRESS;
export const glassPassAddress = process.env.REACT_APP_GLASSPASSADDRESS;
export const serverURL = process.env.REACT_APP_SERVERURL;
export const devURL = process.env.REACT_APP_DEV_URL;
